import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { setAuthToken } from "../utils/authSession";

const Callback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const effectRan = useRef(false);

  useEffect(() => {
    if (effectRan.current) return;
    effectRan.current = true;

    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const redirect_uri = `${window.location.origin}/callback`;

    if (!code) {
      navigate("/admin-login");
      return;
    }

    const baseUrl = process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_API_LOCAL_URL
      : process.env.REACT_APP_API_BASE_URL;
    fetch(`${baseUrl}/auth/discord`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ code, redirect_uri }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.token) {
          setAuthToken(data.token);
          navigate("/");
        } else {
          setAuthToken(null);
          navigate("/admin-login");
        }
      })
      .catch(() => {
        setAuthToken(null);
        navigate("/admin-login");
      });
  }, [location.search, navigate]);

  return <p>Logging you in...</p>;
};

export default Callback;
